import { uniq } from 'lodash';
import { Equipment } from '../../interfaces';
import { LocationEnvironment } from '../../interfaces/locations-environments';
import { LocationSector } from '../../interfaces/locations-sectors';

export interface MapLinksParams {
  equipments?: string[];
  locationSectors?: LocationSector[];
  locationEnvironments?: LocationEnvironment[];
  newEquipments?: Equipment[];
}

export interface MapLinksResult {
  equipmentIds: string[];
  locationSectorIds: string[];
  locationEnvironmentIds: string[];
}

export function mapLinksInput(params: MapLinksParams): MapLinksResult {
  return {
    equipmentIds: extractEquipmentIds(params),
    locationSectorIds: extractSectorIds(params),
    locationEnvironmentIds: extractEnvironmentIds(params),
  };
}

export function extractSectorIds(params: MapLinksParams): string[] {
  const { locationSectors, locationEnvironments, newEquipments } = params;

  const locationSectorIds = [];

  for (const locationSector of locationSectors || []) {
    locationSectorIds.push(locationSector.id);
  }

  for (const locationEnvironment of locationEnvironments || []) {
    if (locationEnvironment.locationSector) {
      locationSectorIds.push(locationEnvironment.locationSector.id);
    }
  }

  for (const equipment of newEquipments || []) {
    if (equipment.locationSector) {
      locationSectorIds.push(equipment.locationSector.id);
    }
  }

  return uniq(locationSectorIds);
}

export function extractEnvironmentIds(params: MapLinksParams): string[] {
  const { locationEnvironments, newEquipments } = params;

  const locationEnvironmentIds = [];

  for (const locationEnvironment of locationEnvironments || []) {
    locationEnvironmentIds.push(locationEnvironment.id);
  }

  for (const equipment of newEquipments || []) {
    if (equipment.locationEnvironment) {
      locationEnvironmentIds.push(equipment.locationEnvironment.id);
    }
  }

  return uniq(locationEnvironmentIds);
}

export function extractEquipmentIds(params: MapLinksParams): string[] {
  const { equipments, newEquipments } = params;

  const equipmentIds = [];

  for (const equipmentId of equipments || []) {
    equipmentIds.push(equipmentId);
  }

  for (const equipment of newEquipments || []) {
    equipmentIds.push(equipment.id);
  }

  return uniq(equipmentIds);
}
